import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProductVariant } from '@interfaces/product'

interface PDPState {
  PDPVariant: ProductVariant | null
}

const initialState: PDPState = {
  PDPVariant: null,
}

const PDPSlice = createSlice({
  name: 'PDP',
  initialState,
  reducers: {
    setPDPVariant(state, action: PayloadAction<ProductVariant>) {
      state.PDPVariant = action.payload
    },
    clearPDPVariant(state) {
      state.PDPVariant = null
    },
  },
})

export const { setPDPVariant, clearPDPVariant } = PDPSlice.actions
export default PDPSlice.reducer
